<div class="c-modal c-modal--d c-modal--help -medium">
  <div class="c-modal__inner">
    <div class="c-modal__head">
      <div class="c-modal__close" (click)="close()">
        <p500-ui-icon name="close" size="20px"></p500-ui-icon>
      </div>
      <div class="c-modal__title">
        {{ title }}
        <div class="c-modal__hint-icon">
          <p500-ui-icon className="text-color" name="other-question"></p500-ui-icon>
        </div>
      </div>
      <div class="c-modal__subtitle" *ngIf="subTitle">{{ subTitle }}</div>
    </div>
    <div class="c-modal__body">
      <div class="c-modal__body--help-info">
        <ng-container *ngTemplateOutlet="content"></ng-container>
      </div>
    </div>
    <div *ngIf="linkToDocs" class="c-modal__footer c-modal__footer--help-info justify-content-start">
      <div class="c-modal__action">
        <a p500-ui-button [href]="linkToDocs" target="_blank" i18n="@@common.go_to_doc_additional">
          Go to Docs for additional information
        </a>
      </div>
    </div>
  </div>
</div>
